export default __webpack_public_path__ + "7cfb3da.png";